import { StyleSheet, Platform, TextStyle } from 'react-native';
import { pick } from 'lodash';
import { useSelector } from 'react-redux';

import { appInfoSelector } from '@common/redux/selectors/app';
import { AppVersion } from 'click-types';
import { checkFont } from '../func';

const createStyles = (attributes: any) => {
  const appInfo = useSelector(appInfoSelector);
  const isV4 = appInfo?.version === AppVersion.V4;
  const style = attributes.style || {};

  const getShadow = () => {
    if (!attributes.shadow) return {};

    return {
      shadowColor: attributes.shadow.color,
      shadowRadius: attributes.shadow.size,
      shadowOpacity: attributes?.shadow?.blur || 0,
      shadowOffset: {
        width: attributes.shadow.x,
        height: attributes.shadow.y,
      },
      elevation:
        attributes?.shadow?.size === 0
          ? attributes?.shadow?.x
          : attributes?.shadow?.size,
    };
  };

  const getFontWeight = () => {
    if (!attributes.fontWeight) return 'normal';

    return typeof attributes.fontWeight === 'string'
      ? attributes.fontWeight
      : attributes.fontWeight.toString();
  };

  return StyleSheet.create({
    container: {
      ...pick(attributes, [
        'marginTop',
        'marginLeft',
        'borderRadius',
        'width',
        'backgroundColor',
        'height',
        'opacity',
        'backgroundColor',
      ]),
      // Override with style object properties if they exist
      ...(attributes.style?.width && { width: attributes.style.width }),
      ...(attributes.style?.height && { height: attributes.style.height }),
      ...(attributes.style?.borderRadius !== undefined && {
        borderRadius: attributes.style.borderRadius,
      }),
      ...(attributes.style?.backgroundColor && {
        backgroundColor: attributes.style.backgroundColor,
      }),
      ...(attributes.style?.marginTop !== undefined && {
        marginTop: attributes.style.marginTop,
      }),
      ...(attributes.style?.marginLeft !== undefined && {
        marginLeft: attributes.style.marginLeft,
      }),
      ...(style?.marginRight !== undefined && {
        marginRight: style.marginRight,
      }),
      ...(style?.marginBottom !== undefined && {
        marginBottom: style.marginBottom,
      }),
      ...(style?.margin !== undefined && {
        margin: style.margin,
      }),
      ...(attributes.style?.opacity !== undefined && {
        opacity: attributes.style.opacity,
      }),
      zIndex: attributes.zIndex,
      ...(attributes.borderStyle !== 'none'
        ? pick(attributes, ['borderWidth', 'borderColor'])
        : {}),
      ...((attributes.style?.borderStyle || attributes.borderStyle) !== 'none'
        ? {
            borderWidth:
              attributes.style?.borderWidth || attributes.borderWidth,
            borderColor:
              attributes.style?.borderColor || attributes.borderColor,
          }
        : {}),
      borderStyle:
        (attributes.style?.borderStyle || attributes.borderStyle) === 'none'
          ? 'solid'
          : attributes.style?.borderStyle || attributes.borderStyle,
      minHeight: attributes.style?.height || attributes.height,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...getShadow(),
      ...(isV4 &&
        pick(style, [
          'top',
          'left',
          'bottom',
          'right',
          'position',
          'transform',
        ])),
    },
    text: {
      ...Platform.select({
        android: {
          lineHeight: attributes.fontSize * 1.15,
        },
      }),
      ...pick(attributes, [
        'color',
        //  'width', 'height',
        'fontSize',
      ]),
      // ...(attributes?.shadow?.size > 0 ? getShadow() : {}),
      // ...getShadow(),
      fontWeight: getFontWeight(),
      // ...pick(attributes, [
      //   // 'backgroundColor',
      //   'fontSize',
      //   // 'padding',
      //   'opacity',
      // ]),
      // ...(attributes.borderStyle !== 'none'
      //   ? pick(attributes, ['borderWidth', 'borderColor'])
      //   : {}),
      // borderStyle:
      //   attributes.borderStyle === 'none' ? 'solid' : attributes.borderStyle,
      // minHeight: attributes.height,
      fontFamily: checkFont(attributes.fontFamily),
      // Override with style object properties if they exist
      ...(attributes.style?.color && { color: attributes.style.color }),
      ...(attributes.style?.fontSize && {
        fontSize: attributes.style.fontSize,
      }),
      ...(attributes.style?.fontFamily && {
        fontFamily: checkFont(attributes.style.fontFamily),
      }),
      ...(attributes.style?.fontWeight && {
        fontWeight:
          typeof attributes.style.fontWeight === 'string'
            ? attributes.style.fontWeight
            : attributes.style.fontWeight.toString(),
      }),
      // paddingTop: 0,
      // paddingBottom: 0,
      // update for bug android not same ios
      // paddingLeft: attributes?.padding || 0,
      // overflow: 'hidden',
    },
  });
};

export const errorStyles = StyleSheet.create({
  errorWrapper: {
    borderStyle: 'solid' as TextStyle['borderStyle'],
    borderWidth: 1,
    borderColor: 'red',
  },
  errorMessage: {
    color: 'red',
    fontSize: 12,
    fontWeight: 'normal' as TextStyle['fontWeight'],
  },
});

export default createStyles;
